import React from 'react';
import styled from 'styled-components';
import Navbar from './Navbar';
import DesktopMenu from './DesktopMenu';
import Footer from './Footer';
import coverImg from '../images/gumroad_cover_container.png';

const GUMROAD_URL = 'https://spectralcenter.gumroad.com/l/container?layout=profile';

const TheContainer = () => {
    return (
        <>
            <Navbar/>
            <DeskWrap>
                <DesktopMenu/>
                <Wrapper>
                    <Body>
                        <h1>The Container</h1>
                        <Sub>A Practice in Boundaries, Self-Trust, and Creative Life Force</Sub>
                        <Price>€44</Price>
                        <CoverImage src={coverImg} alt="The Container" />

                        <p>There's a part of you that already knows how to hold yourself — how to say no, how to generate joy, art, desire, and discipline from trust rather than chaos. When that part is working, you feel like a vessel: solid, sensual, discerning, full of something worth protecting. When it isn't, you feel like a leaky bucket, drained by people-pleasing, emotional fatigue, and cycles of doing just enough to get by.</p>

                        <p>The Container is built to help you remember that part, and start working from it again.</p>

                        <h3>This is for you if</h3>
                        <p>Your needs and desires feel just out of reach. You're exhausted from giving more than you receive. You keep finding yourself in people-pleasing or codependent patterns. Or you're simply ready to stop leaking energy and start directing it with purpose.</p>

                        <h3>What this shifts</h3>
                        <p>This work is about rebuilding self-trust through consistency, clarity, and follow-through. Through hypnosis, ritual, and repetition, you'll work on turning shame into something usable, saying no without guilt, setting boundaries that actually hold, telling the difference between what's important and what's just urgent, finishing what you start — and, underneath all of it, making your word mean something to yourself again.</p>

                        <h3>What you'll receive</h3>
                        <p>A four-part self-hypnosis journey, unfolding over four weeks or forty days, built from four long-form rituals plus daily support audio and tools for integration.</p>

                        <p>The four weekly rituals, each 30 to 45 minutes: Hypnosis for Self-Establishment, Deep Clearing — a regression for shame, Hypnosis for Boundaries and Discernment, and Hypnosis for Creativity and the Erotic.</p>

                        <p>Daily support includes a 15-minute confidence hypnosis and a 7-minute "no" meditation, plus weekly journal prompts, optional homework, and a suggested practice calendar to help you stay in rhythm.</p>

                        <h3>More than a course</h3>
                        <p>It's a container — a self-holding practice, a way of sealing the leaks and making room for joy, sex, art, and rest. All materials are downloadable and yours to keep, available on your own schedule from the moment you join.</p>

                        <BuyButton href={GUMROAD_URL} target="_blank" rel="noopener noreferrer">Access The Container</BuyButton>
                    </Body>
                </Wrapper>
            </DeskWrap>
            <Footer/>
        </>
    )
}

const DeskWrap = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;

    @media (min-width: 1000px) {
        flex-direction: row;
    }
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 90vh;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;

    @media (min-width: 1000px) {
        padding: 2rem;
    }
`

const Body = styled.div`
    font-family: var(--font-body);
    width: 95%;
    padding: 0 1rem;
    max-width: 100%;

    h1 {
        font-size: 1.8rem;
        margin-bottom: 0.4rem;
        color: #333;
    }

    h3 {
        font-size: 1.2rem;
        margin: 1.75rem 0 0.75rem;
        color: #333;
    }

    p {
        line-height: 1.7;
        margin-bottom: 1.1rem;
        color: #444;
    }

    @media (min-width: 1000px) {
        max-width: 65ch;
        padding: 0 1rem;
    }
`

const Sub = styled.p`
    font-style: italic;
    font-size: 1.05rem;
    color: #666;
    margin: 0 0 0.75rem;
`

const Price = styled.p`
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    margin: 0 0 1.25rem;
`

const CoverImage = styled.img`
    width: 100%;
    max-width: 480px;
    display: block;
    margin: 0 0 1.75rem;
    transform: rotate(0.8deg);
    box-shadow: 0 4px 14px rgba(0,0,0,0.15);
`

const BuyButton = styled.a`
    display: inline-block;
    margin-top: 1rem;
    padding: 0.85rem 1.75rem;
    background: #333;
    color: #fff;
    text-decoration: none;
    border-radius: 0.4rem;
    font-weight: 600;
    transition: background 0.2s ease;

    &:hover {
        background: #000;
    }
`

export default TheContainer;